module.exports = __webpack_public_path__ + "static/img/2.7983226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 1